import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ApiLoadingProvider } from './context/ApiLoadingContext';
import { AuthProvider } from './context/Authcontext';
import { GlobalErrorProvider } from './context/GlobalErrorContext';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { GuestRoute, ProtectedRoute } from './components/AuthRoutes';
import Navbar from './components/Navbar';

import Home        from './pages/Home';
import Login       from './pages/Login';
import Dashboard   from './pages/Dashboard';
import Network     from './pages/Network';
import Earnings    from './pages/Earnings';
import Withdrawal  from './pages/Withdrawal';
import Community   from './pages/Community';
import Leaderboard from './pages/Leaderboard';
import Membership  from './pages/Membership';
import Profile     from './pages/Profile';
import AdminPanel  from './pages/Adminpanel';
import Plans       from './pages/Plans';
import PaymentQrScreen from './pages/PaymentQrScreen';
import PaymentProofUpload from './pages/PaymentProofUpload';
import PaymentRetryUpload from './pages/PaymentRetryUpload';
import AccountRecoveryPay from './pages/AccountRecoveryPay';
import PaymentVerificationStatus from './pages/PaymentVerificationStatus';
import UserPlansTabs from './pages/UserPlansTabs';
import About from './pages/About';
import Rewards from './pages/Rewards';
import Products from './pages/Products';

import {
  VerifyEmailPage,
  ForgotPasswordPage,
  ResetPasswordPage,
} from './pages/Login';

function App() {
  return (
    <ApiLoadingProvider message="Loading…">
      <Router>
        <AuthProvider>
          <GlobalErrorProvider>
            <AppErrorBoundary>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/rewards" element={<Rewards />} />
                <Route path="/products" element={<Products />} />
                <Route path="/plans" element={<Plans />} />
                <Route path="/verify-email" element={<VerifyEmailPage />} />

                <Route element={<GuestRoute />}>
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                </Route>

                <Route element={<ProtectedRoute />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/network" element={<Network />} />
                  <Route path="/earnings" element={<Earnings />} />
                  <Route path="/withdrawal" element={<Withdrawal />} />
                  <Route path="/community" element={<Community />} />
                  <Route path="/leaderboard" element={<Leaderboard />} />
                  <Route path="/membership" element={<Membership />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/payment" element={<PaymentQrScreen />} />
                  <Route path="/payment/upload" element={<PaymentProofUpload />} />
                <Route path="/payment/re-upload" element={<PaymentRetryUpload />} />
                <Route path="/payment/status" element={<PaymentVerificationStatus />} />
                <Route path="/payments" element={<UserPlansTabs />} />
                </Route>

                <Route path="/account-recovery" element={<AccountRecoveryPay />} />

                <Route path="/admin-panel" element={<AdminPanel />} />
              </Routes>
            </AppErrorBoundary>
          </GlobalErrorProvider>
        </AuthProvider>
      </Router>
    </ApiLoadingProvider>
  );
}

export default App;
